
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/blognami-saas/lib/views/--portal/index.js";
                const hash = "4C9Hcis1wm";
                Component.include(createDecoratorsInclude(hash, decorators));
            